import { createActionType, createRequestTypes } from 'app/lib/actionTypes';

export const LOGIN = createRequestTypes('LOGIN');

export const LOGOUT = createActionType('LOGOUT');
